import { createSelector } from 'reselect'
import widgetTypes from 'helpers/enums/widgetTypes'

const getStore = state => state.store
const getUI = state => state.ui

const storeWidgetsSelector = createSelector(
	[ getStore, getUI ],
	(storeData, uiData) => {
		let widgets = []

		// When window size is lower than 1200px show all widgets
		const showAllWidgets = uiData.width < 1200

		if (storeData && storeData.catalog && storeData.catalog.widgets) {
			widgets = storeData.catalog.widgets
				.filter( widget => widget.type !== widgetTypes.HIGHLIGHT )
				.filter( (widget, index) => index < 6 )
		}

		const widgetTabs = widgets.map(widget => ({
			tabId: widget.id,
			tabName: widget.title,
			isNew: widget.isNew,
		}))

		return {
			widgets,
			widgetTabs,
			showAllWidgets,
		}
	}
)

export default storeWidgetsSelector
